import ZoomInDown from './zoom-in-down'
import ZoomInLeft from './zoom-in-left'
import ZoomInRight from './zoom-in-right'
import ZoomInUp from './zoom-in-up'
import ZoomIn from './zoom-in'

export default {
  ZoomIn,
  ZoomInDown,
  ZoomInLeft,
  ZoomInRight,
  ZoomInUp
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/zoom-entrances/index.js